// DO NOT EDIT
  // this file is generated by /internals/populate-icons script
  import * as React from 'react'
  // @ts-ignore
  import { FileText } from 'react-feather'
  import IconBase from './../../IconBase'

  function IconFileText(props: any) {
    return <IconBase icon={FileText} {...props} />
  }

  export default IconFileText
  